"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importStar(require("react"));
var Accordion_1 = __importDefault(require("../common/Accordion"));
var react_i18next_1 = require("react-i18next");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var PlayerTypes_1 = __importDefault(require("@/functions/PlayerTypes"));
var styles_1 = require("@mui/material/styles");
var react_admin_1 = require("react-admin");
var material_1 = require("@mui/material");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var PlayerDetailsModal_1 = __importDefault(require("./PlayerDetailsModal"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var IsOnlineField_1 = __importDefault(require("./IsOnlineField"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AddPresentationModal_1 = __importDefault(require("./AddPresentationModal"));
var ResourceAccessModal_1 = __importDefault(require("../common/ResourceAccessModal"));
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var PlayerDeleteErrorModal_1 = __importDefault(require("./PlayerDeleteErrorModal"));
var AddEventModal_1 = __importDefault(require("./AddEventModal"));
var AddMetadataModal_1 = __importDefault(require("./AddMetadataModal"));
var PlayerCard = function (_a) {
    var group = _a.group, setSelectedPlayerProp = _a.setSelectedPlayerProp, toggle = _a.toggle, openResourceAccessModal = _a.openResourceAccessModal, deletePlayer = _a.deletePlayer, permissions = _a.permissions;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var resource = (0, react_admin_1.useRecordContext)();
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)(false), isHovered = _b[0], setIsHovered = _b[1];
    var savePlayerGroup = function (playerGroup) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.updatePlayerGroup(resource.id, playerGroup.id).then(function () {
                            refresh();
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _c = (0, react_dnd_1.useDrag)(function () { return ({
        type: "player",
        end: function (_item, monitor) {
            var dropResult = monitor.getDropResult();
            savePlayerGroup(dropResult);
        },
        collect: function (monitor) { return ({
            opacity: monitor.isDragging() ? 0.5 : 1,
        }); },
    }); }, []), opacity = _c[0].opacity, dragRef = _c[1];
    var handleManageResourceAccess = function () {
        openResourceAccessModal(resource.id, resource.name, "Resource");
    };
    var handleManageGroupAccess = function () {
        var _a;
        openResourceAccessModal(Number(resource.player_group_id), ((_a = resource.player_group) === null || _a === void 0 ? void 0 : _a.name) || "", "Group");
    };
    return (resource.player_group_id == group.id && (react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaPaperTheme },
        react_1.default.createElement("div", { onMouseEnter: function () {
                setIsHovered(true);
            }, onMouseLeave: function () {
                setIsHovered(false);
            } },
            react_1.default.createElement(material_1.Paper, { ref: dragRef, style: { opacity: opacity }, variant: "outlined", square: true, "data-cy": "playerCard", className: Players_module_css_1.default.mui_paper, onClick: function () {
                    setSelectedPlayerProp(resource);
                    toggle();
                } },
                react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between", style: { height: "45px", whiteSpace: "nowrap" } },
                    react_1.default.createElement(react_admin_1.TextField, { source: "name", sortable: false, "data-cy": "playerCardName", title: resource.name }),
                    react_1.default.createElement("div", { style: { width: "25px", margin: "10px", marginRight: "0px" } },
                        react_1.default.createElement("img", { src: PlayerTypes_1.default.getPlayerTypeIconByDeviceId(resource.device_type_id), title: resource.device_type.name, className: Players_module_css_1.default.os_image }))),
                react_1.default.createElement(IsOnlineField_1.default, { view: "grid" }),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Modify"), size: "small", variant: "primary", style: { height: "25px", marginTop: "20px" }, className: "d-flex align-items-center" }),
                react_1.default.createElement(AccessControl_1.default, { resourceType: types_1.ResourceType.PLAYER.toLowerCase() + "s", optionalPermissions: __spreadArray(__spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true), ["edit-user-management"], false) },
                    react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () {
                            setSelectedPlayerProp(resource);
                            toggle();
                        }, onDelete: function () {
                            setSelectedPlayerProp(resource);
                            deletePlayer(resource.id);
                        }, onManageResourceAccess: handleManageResourceAccess, onManageGroupAccess: handleManageGroupAccess, style: {
                            position: "relative", bottom: "130px", left: "205px", display: isHovered ? "inline-block" : "none"
                        }, menuSx: { marginLeft: "25px", marginBottom: "200px" }, resourceType: types_1.ResourceType.PLAYER, resourceId: resource.id })))))));
};
var DroppableArea = function (_a) {
    var children = _a.children, groupId = _a.groupId;
    var _b = (0, react_dnd_1.useDrop)({
        accept: "player",
        drop: function () { return ({ id: groupId }); },
    }), drop = _b[1];
    return react_1.default.createElement("div", { ref: drop }, children);
};
var PlayersGridView = function (_a) {
    var playerGroups = _a.playerGroups, handlePlayerGroupsDeletion = _a.handlePlayerGroupsDeletion, refreshPlayerGroups = _a.refreshPlayerGroups, permissions = _a.permissions;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var filters = [react_1.default.createElement(react_admin_1.SearchInput, { source: "name", alwaysOn: true, key: "queryFilter", "data-cy": "playersGridViewSearch", placeholder: t("Search") })];
    var _b = (0, react_1.useState)(null), selectedPlayer = _b[0], setSelectedPlayer = _b[1];
    var _c = (0, react_1.useState)(false), playerDetailsModalShown = _c[0], setPlayerDetailsModalShown = _c[1];
    var _d = (0, react_1.useState)(false), addPresentationModalShown = _d[0], setAddPresentationModalShown = _d[1];
    var _e = (0, react_1.useState)(false), addEventModalShown = _e[0], setAddEventModalShown = _e[1];
    var _f = (0, react_1.useState)(false), addMetadataModalShown = _f[0], setAddMetadataModalShown = _f[1];
    var logger = q_play_core_1.logManager.getLogger();
    var _g = (0, react_1.useState)("player-details"), active = _g[0], setActive = _g[1];
    var refresh = (0, react_admin_1.useRefresh)();
    var _h = (0, react_1.useState)(false), confirmationModalOpened = _h[0], setConfirmationModalOpened = _h[1];
    var _j = (0, react_1.useState)(false), resourceAccessModalShown = _j[0], setResourceAccessModalShown = _j[1];
    var _k = (0, react_1.useState)(null), currentGroupId = _k[0], setCurrentGroupId = _k[1];
    var _l = (0, react_1.useState)(""), resourceName = _l[0], setResourceName = _l[1];
    var _m = (0, react_1.useState)("Group"), currentType = _m[0], setCurrentType = _m[1];
    var _o = (0, react_1.useState)(null), currentResourceId = _o[0], setCurrentResourceId = _o[1];
    var _p = (0, react_1.useState)(false), playerDeleteErrorModalShown = _p[0], setPlayerDeleteErrorModalShown = _p[1];
    var _q = (0, react_1.useState)({}), playerDeleteErrorResponse = _q[0], setPlayerDeleteErrorResponse = _q[1];
    var PlayersGridContent = function (_a) {
        var playerGroups = _a.playerGroups, permissions = _a.permissions;
        var playersData = (0, react_admin_1.useListContext)().data;
        var playerGroupCounts = (0, react_1.useMemo)(function () {
            if (playersData && playerGroups) {
                var counts_1 = {};
                playerGroups.forEach(function (group) {
                    counts_1[group.id] = playersData.filter(function (p) { return p.player_group_id === group.id; }).length;
                });
                return counts_1;
            }
            else {
                return {};
            }
        }, [playersData, playerGroups]);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: Players_module_css_1.default.searchbar_container },
                react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSearchInputTheme },
                    react_1.default.createElement(react_admin_1.FilterForm, { filters: filters })),
                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", className: "".concat(Players_module_css_1.default.filter_button, " d-flex align-items-center justify-content-center") },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBarsFilter, style: { fontSize: "28px" }, color: "var(--info-color)" }))),
            react_1.default.createElement("div", { style: { position: "relative", top: "-65px" } }, playerGroups === null || playerGroups === void 0 ? void 0 : playerGroups.sort(function (a, b) { return a.name.localeCompare(b.name, navigator.language || navigator.languages[0], { sensitivity: "base" }); }).map(function (playerGroup) { return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend, key: playerGroup.id },
                react_1.default.createElement(DroppableArea, { groupId: playerGroup.id },
                    react_1.default.createElement(Accordion_1.default, { defaultActiveKey: "0", onTrashClick: function () { return onGroupDelete(playerGroup.id); }, isDisabled: playerGroupCounts[playerGroup.id] > 0, isLast: playerGroups.length === 1, type: types_1.ResourceType.PLAYER, permissions: permissions, id: playerGroup.id, name: playerGroup.name, onSave: updatePlayerGroupName, onResourceAccessModalClick: function (groupId) {
                            return openResourceAccessModal(groupId, playerGroup.name, "Group");
                        } },
                        react_1.default.createElement(react_admin_1.SingleFieldList, { linkType: false },
                            react_1.default.createElement(PlayerCard, { group: playerGroup, setSelectedPlayerProp: selectedPlayerHandler, toggle: togglePlayerDetailsModal, openResourceAccessModal: openResourceAccessModal, deletePlayer: deletePlayer, permissions: permissions })))))); }))));
    };
    var toggleConfirmationModal = function () {
        setConfirmationModalOpened(function (prevState) { return !prevState; });
        setPlayerDetailsModalShown(function (prevState) { return !prevState; });
    };
    var deletePlayer = function (currentResourceId) { return __awaiter(void 0, void 0, void 0, function () {
        var resourceId, response, _a, players_and_presentation_details, players_and_event_details, hasPresentations, hasEvents, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resourceId = currentResourceId || (selectedPlayer ? selectedPlayer.id : null);
                    if (!resourceId) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.deletePlayer(resourceId)];
                case 2:
                    response = _b.sent();
                    if (response.data.error) {
                        _a = response.data.data, players_and_presentation_details = _a.players_and_presentation_details, players_and_event_details = _a.players_and_event_details;
                        hasPresentations = players_and_presentation_details && players_and_presentation_details.length > 0;
                        hasEvents = players_and_event_details && players_and_event_details.length > 0;
                        if (hasPresentations || hasEvents) {
                            setPlayerDeleteErrorResponse({
                                message: response.data.error,
                                data: __spreadArray(__spreadArray([], (players_and_presentation_details || []).map(function (detail) { return (__assign(__assign({}, detail), { resource_type: "PRESENTATION" })); }), true), (players_and_event_details || []).map(function (detail) { return (__assign(__assign({}, detail), { resource_type: "EVENT" })); }), true)
                            });
                            setPlayerDeleteErrorModalShown(true);
                        }
                    }
                    else {
                        setPlayerDeleteErrorResponse({});
                        setPlayerDeleteErrorModalShown(false);
                    }
                    setConfirmationModalOpened(false);
                    setPlayerDetailsModalShown(false);
                    refresh();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    logger.error("Failed to delete player:", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var closeDeletePlayerErrorModal = function () {
        setPlayerDeleteErrorResponse({});
        setPlayerDeleteErrorModalShown(false);
    };
    var togglePlayerDetailsModal = function () {
        setActive("player-details");
        setPlayerDetailsModalShown(function (shown) { return !shown; });
    };
    var openResourceAccessModal = function (id, name, type) {
        var _a;
        if (type === "Group") {
            setCurrentGroupId(id);
            var groupName = (_a = playerGroups.find(function (group) { return group.id === id; })) === null || _a === void 0 ? void 0 : _a.name;
            setResourceName(groupName || "");
            setCurrentType("Group");
        }
        else if (type === "Resource") {
            setCurrentResourceId(id);
            setResourceName(name);
            setCurrentType("Resource");
        }
        setResourceAccessModalShown(true);
    };
    var closeResourceAccessModal = function () { return setResourceAccessModalShown(false); };
    (0, react_1.useEffect)(function () {
        if (addPresentationModalShown) {
            setPlayerDetailsModalShown(false);
        }
    }, [addPresentationModalShown]);
    var toggleAddPresentations = function () {
        setPlayerDetailsModalShown(function (shown) { return !shown; });
        setAddPresentationModalShown(function (shown) { return !shown; });
    };
    var toggleAddEvents = function () {
        setPlayerDetailsModalShown(function (shown) { return !shown; });
        setAddEventModalShown(function (shown) { return !shown; });
    };
    var toggleAddMetadata = function () {
        setPlayerDetailsModalShown(function (shown) { return !shown; });
        setAddMetadataModalShown(function (shown) { return !shown; });
    };
    var selectedPlayerHandler = function (player) {
        setSelectedPlayer(player);
    };
    var onGroupDelete = function (playerGroupId) {
        ApiManager_1.default.deletePlayerGroups(playerGroupId)
            .then(function () {
            var updatedGroups = playerGroups.filter(function (group) { return group.id !== playerGroupId; });
            handlePlayerGroupsDeletion(updatedGroups);
        })
            .catch(function (error) { return logger.error(error); });
    };
    var updatePlayerGroupName = function (playerGroupId, groupName) {
        var trimmedNewName = groupName.trim();
        var currentGroup = playerGroups.find(function (group) { return group.id === playerGroupId; });
        if (!trimmedNewName || trimmedNewName === (currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.name)) {
            return;
        }
        ApiManager_1.default.updatePlayerGroupName(playerGroupId, groupName)
            .then(function () {
            refreshPlayerGroups();
        })
            .catch(function (error) {
            logger.error("Failed to update player group name:", error);
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_admin_1.InfiniteList, { resource: "players", exporter: false, sx: {
                "& .RaList-content": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                },
            }, queryOptions: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchOnMount: true,
                refetchInterval: 1000 * 60,
            } },
            react_1.default.createElement(PlayersGridContent, { playerGroups: playerGroups, permissions: permissions })),
        react_1.default.createElement(PlayerDetailsModal_1.default, { isShown: playerDetailsModalShown, toggle: togglePlayerDetailsModal, player: selectedPlayer, active: active, setActiveProp: setActive, toggleAddPresentations: toggleAddPresentations, toggleAddEvents: toggleAddEvents, toggleAddMetadata: toggleAddMetadata, toggleConfirmationModal: toggleConfirmationModal, confirmationModalOpened: confirmationModalOpened, permissions: permissions, resourceType: types_1.ResourceType.PLAYER.toLowerCase() + "s" }),
        react_1.default.createElement(AddPresentationModal_1.default, { isShown: addPresentationModalShown, toggle: toggleAddPresentations, player: selectedPlayer, active: active, setActiveProp: setActive, type: types_1.ResourceType.PLAYER }),
        react_1.default.createElement(AddEventModal_1.default, { isShown: addEventModalShown, toggle: toggleAddEvents, players: selectedPlayer ? [selectedPlayer] : [], setPlayerDetailsModalShown: setPlayerDetailsModalShown, bulkAction: false }),
        react_1.default.createElement(AddMetadataModal_1.default, { isShown: addMetadataModalShown, toggle: toggleAddMetadata, player: selectedPlayer, setPlayerDetailsModalShown: setPlayerDetailsModalShown }),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: confirmationModalOpened, onClose: toggleConfirmationModal, onConfirm: function () { return deletePlayer(currentResourceId); }, onCancel: toggleConfirmationModal, headerText: t("Confirm"), message: t("Are you sure?"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true }),
        react_1.default.createElement(ResourceAccessModal_1.default, { isShown: resourceAccessModalShown, onClose: closeResourceAccessModal, resourceType: types_1.ResourceType.PLAYER, type: currentType, resourceName: resourceName, groupId: currentGroupId, resourceId: currentResourceId }),
        react_1.default.createElement(PlayerDeleteErrorModal_1.default, { isShown: playerDeleteErrorModalShown, onClose: closeDeletePlayerErrorModal, message: playerDeleteErrorResponse.message, data: playerDeleteErrorResponse.data, resourceId: selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id, deleteResourceMethod: deletePlayer })));
};
exports.default = PlayersGridView;
